export enum EPaymentCardType {
    VISA = "VISA",
    MC = "MC",
    AMEX = "AMEX",
    CB = "CB",
    DINERS = "DINERS",
    JCB = "JCB",
}

export interface ISimplePaymentMethodCard {
    providerReference: string;
    partialDigits: string;
    cardholderName: string;
    expirationDate: string;
    creditCardType: EPaymentCardType;
}
